import { prop } from '@lib/style/theme';
import { cleanProps } from '@lib/utils';
import { css } from 'styled-components';
import { unitStrict } from '../unit';

export interface HeightProps {
    h: number | string;
    height: number | string;
}

export const height = (defaultValue?: HeightProps['height']): any => css`
    & {
        height: ${prop(['h', 'height'], defaultValue, unitStrict)};
    }
`;

height.clean = (props): any => cleanProps(props, ['h', 'height']);
